// Style
import style from "./terms.module.scss";

// Components
import Link from "next/link";

export default function Terms({ terms }) {
  return (
    <div className={style.terms}>
      {terms &&
        terms.map((term, index) => {
          return (
            <div className={style.term} key={term.id}>
              <Link href={term.uri}>{term.name}</Link>
              {terms.length > index + 1 && <p>,&nbsp;</p>}
            </div>
          );
        })}
    </div>
  );
}
